export default __webpack_public_path__ + "static/13-3d0116ce726c930ecbfaf65ddfa9fc7d.webp";